"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0.3 -1 16 16';

var Information = function Information() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M7.5075,0.45395 C3.565,0.45395 0.37,3.64945 0.37,7.59095 C0.37,11.53345 3.565,14.72895 7.5075,14.72895 C11.4495,14.72895 14.645,11.53345 14.645,7.59095 C14.645,3.64945 11.4495,0.45395 7.5075,0.45395 M7.5075,1.56895 C10.8285,1.56895 13.5295,4.27045 13.5295,7.59095 C13.5295,10.91195 10.8285,13.61345 7.5075,13.61345 C4.1865,13.61345 1.485,10.91195 1.485,7.59095 C1.485,4.27045 4.1865,1.56895 7.5075,1.56895"
  }), _react["default"].createElement("path", {
    d: "M7.0612,6.9222 L7.9532,6.9222 C8.1997,6.9222 8.3997,7.1217 8.3997,7.3687 L8.3997,11.6062 C8.3997,11.8527 8.1997,12.0527 7.9532,12.0527 L7.0612,12.0527 C6.8147,12.0527 6.6147,11.8527 6.6147,11.6062 L6.6147,7.3687 C6.6147,7.1217 6.8147,6.9222 7.0612,6.9222"
  }), _react["default"].createElement("path", {
    d: "M7.5075,5.58385 C8.123,5.58385 8.6225,5.08435 8.6225,4.46885 C8.6225,3.85285 8.123,3.35335 7.5075,3.35335 C6.8915,3.35335 6.3925,3.85285 6.3925,4.46885 C6.3925,5.08435 6.8915,5.58385 7.5075,5.58385"
  }));
};

var _default = (0, _createSvgIcon["default"])(Information, {
  viewBox: viewBox
});

exports["default"] = _default;